interface ApiResponse<T> {
  message: string
  data: T
  correlationId?: string
}
export interface HttpResponse<T> extends Response {
  parsedBody?: ApiResponse<T>
}

export const request = async <T>(request: RequestInfo): Promise<HttpResponse<T>> => {
  const response: HttpResponse<T> = await fetch(request)

  try {
    response.parsedBody = await response.json()
  } catch (ex) {}

  return response
}

export const get = async <T>(
  path: string,
  args: RequestInit = {
    method: 'get',
    headers: {
      Authorization:
        localStorage.getItem('token') !== null ? `Bearer ${localStorage.getItem('token')?.slice(1, -1)}` : '',
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    credentials: 'include',
  },
): Promise<HttpResponse<T>> => {
  return await request<T>(new Request(path, args))
}

export const post = async <T>(
  path: string,
  body: unknown,
  args: RequestInit = {
    method: 'POST',
    headers: {
      Authorization:
        localStorage.getItem('token') !== null ? `Bearer ${localStorage.getItem('token')?.slice(1, -1)}` : '',
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    credentials: 'include',
    body: JSON.stringify(body),
  },
): Promise<HttpResponse<T>> => {
  return await request<T>(new Request(path, args))
}

export const postForm = async <T>(path: string, formData: FormData): Promise<HttpResponse<T>> => {
  const response: HttpResponse<T> = await fetch(path, {
    method: 'POST',
    headers: {
      Authorization:
        localStorage.getItem('token') !== null ? `Bearer ${localStorage.getItem('token')?.slice(1, -1)}` : '',
    },
    mode: 'cors',
    credentials: 'include',
    body: formData,
  })

  try {
    // Assuming the server responds with JSON,
    // parse the response and assign to parsedBody
    response.parsedBody = (await response.json()) as ApiResponse<T>
  } catch (ex) {
    // Error parsing response - silently fail as this is expected for some responses
  }

  return response
}

export const put = async <T>(
  path: string,
  body: unknown,
  args: RequestInit = { method: 'put', body: JSON.stringify(body) },
): Promise<HttpResponse<T>> => {
  return await request<T>(new Request(path, args))
}
